import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { AccordionCohabitationVM } from 'cohabitation/view-models/detail-cohabitation';

interface FormCohabitatonDataProps {
  disabled?: boolean;
  values?: AccordionCohabitationVM;
  isEditMode?: boolean;
  onChange: (
    key: keyof AccordionCohabitationVM,
    value: AccordionCohabitationVM[keyof AccordionCohabitationVM]
  ) => void;
}

const FormCohabitatonDataComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
}: FormCohabitatonDataProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Identificativo ANPR"
          label="Identificativo ANPR"
          id="idANPR"
          name="idANPR"
          fullWidth
          type="text"
          disabled
          onChange={(event) => {
            onChange('idANPR', event.target.value);
          }}
          variant="outlined"
          value={values?.idANPR || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Identificativo Comune"
          label="Identificativo Comune"
          id="municipalityId"
          name="municipalityId"
          fullWidth
          type="text"
          disabled
          onChange={(event) => {
            onChange('municipalityIdentifier', event.target.value);
          }}
          variant="outlined"
          value={values?.municipalityIdentifier || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Codice ISTAT"
          label="Codice ISTAT"
          id="istatCode"
          name="istatCode"
          fullWidth
          type="text"
          disabled={isEditMode ? false : disabled}
          onChange={(event) => {
            onChange('istatCode', event.target.value);
          }}
          variant="outlined"
          value={values?.istatCode || ''}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          aria-label="Descrizione"
          label="Descrizione"
          id="description"
          name="description"
          fullWidth
          type="text"
          disabled
          onChange={(event) => {
            onChange('nameCohabitation', event.target.value);
          }}
          variant="outlined"
          value={values?.nameCohabitation || ''}
        />
      </Grid>
    </Grid>
  );
};

FormCohabitatonDataComponent.displayName = 'Form Cohabitation data component';

const FormCohabitatonData = memo(FormCohabitatonDataComponent);

export default FormCohabitatonData;
